import React, { useState, useEffect } from 'react';
import '../styles/hack.css';

const HackAnimation = ({ target }) => {
  const [phase, setPhase] = useState(0);
  const [progress, setProgress] = useState(0);
  const [logs, setLogs] = useState([]);

  const hackSteps = [
    { text: `[*] Initiating attack on ${target}...`, delay: 0, color: '#b06bff' },
    { text: `[*] Scanning ports...`, delay: 500, color: '#b06bff' },
    { text: `[+] Found 3 open ports: 22, 80, 443`, delay: 1000, color: '#00ff88' },
    { text: `[*] Attempting SSH brute force...`, delay: 1500, color: '#b06bff' },
    { text: `[!] Access denied. Trying alternative method...`, delay: 2500, color: '#ffbd2e' },
    { text: `[*] Exploiting SQL injection vulnerability...`, delay: 3000, color: '#b06bff' },
    { text: `[*] Uploading payload...`, delay: 4000, color: '#b06bff' },
    { text: `[*] Establishing reverse shell...`, delay: 5500, color: '#b06bff' },
    { text: `[+] Connection established!`, delay: 6500, color: '#00ff88' },
    { text: `[*] Escalating privileges...`, delay: 7000, color: '#b06bff' },
    { text: `[*] Bypassing firewall...`, delay: 7800, color: '#b06bff' },
    { text: `[+] Root access granted!`, delay: 8500, color: '#00ff88' },
    { text: `[+] ${target.toUpperCase()} PWNED!`, delay: 9000, color: '#d9a6ff' },
    { text: `[!] Warning: This is a simulation for educational purposes only.`, delay: 9500, color: '#ff5f57' }
  ];

  useEffect(() => {
    hackSteps.forEach((step, index) => {
      setTimeout(() => {
        setLogs(prev => [...prev, step]);
        setPhase(index);
      }, step.delay);
    });

    // Progress bar animation
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 95);

    return () => clearInterval(interval);
  }, [target]);

  return (
    <div className="hack-container">
      <div className="hack-header">
        <div className="hack-title">
          <span className="hack-skull">💀</span>
          <span className="hack-text">CYBER ATTACK IN PROGRESS</span>
          <span className="hack-skull">💀</span>
        </div>
        <div className="hack-target">TARGET: {target.toUpperCase()}</div>
      </div>

      <div className="hack-progress-container">
        <div className="hack-progress-bar">
          <div 
            className="hack-progress-fill" 
            style={{ width: `${progress}%` }}
          >
            <span className="hack-progress-text">{progress}%</span>
          </div>
        </div>
      </div>

      <div className="hack-logs">
        {logs.map((log, index) => (
          <div 
            key={index} 
            className={`hack-log ${phase === index ? 'active' : ''}`}
            style={{ color: log.color }}
          >
            {log.text}
          </div>
        ))}
      </div>

      {phase >= hackSteps.length - 1 && (
        <div className="hack-complete">
          <div className="hack-skull-large">💀</div>
          <div className="hack-complete-text">SYSTEM COMPROMISED</div>
        </div>
      )}

      <div className="hack-matrix">
        {[...Array(30)].map((_, i) => (
          <span key={i} style={{ 
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${2 + Math.random() * 3}s`
          }}>
            {String.fromCharCode(33 + Math.floor(Math.random() * 94))}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HackAnimation;
